'use client';
import { useSearchParams } from 'next/navigation';
import * as React from 'react';

export const useQueryParam = (queryKey: string, _default?: any) => {
  const searchParams = useSearchParams();

  return React.useMemo(() => {
    const value = searchParams?.get(queryKey);
    return value ?? _default;
  }, [searchParams, queryKey, _default]);
};
